import { useReactiveVar } from "@apollo/client";
import { mobileAppModel } from "../../state";
import {
  LanguagesEnum,
  useGetAvailableLanguagesQuery,
} from "../../../../../generated/graphql";
import { Autocomplete } from "@material-ui/lab";
import { ModalInput } from "../../../../shared/Style/Style";

export const SelectLanguage = () => {
  const model = useReactiveVar(mobileAppModel.model);
  const inputErrors = useReactiveVar(mobileAppModel.inputErrors);
  const isLoading = useReactiveVar(mobileAppModel.updateLoading);
  const { data, loading } = useGetAvailableLanguagesQuery();

  const languages = data?.getAvailableLanguages ?? [];

  if (loading) return null;

  return (
    <Autocomplete
      disabled={isLoading}
      options={languages.map(({ code }) => code)}
      value={model?.lang || LanguagesEnum.Ukr}
      onChange={(_, value) =>
        mobileAppModel.setLanguage(value as LanguagesEnum)
      }
      onFocus={() => mobileAppModel.setInputErrors("language", false)}
      getOptionLabel={(option) =>
        languages.find(({ code }) => code === option)?.nameUkr || option
      }
      renderInput={(params) => {
        return (
          <ModalInput
            {...params}
            error={inputErrors.language.error}
            margin="normal"
            fullWidth
            label="Мова"
            required
          />
        );
      }}
    />
  );
};